<template>
<div>
    <b-table 
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage">

        <template v-slot:cell(actions)="data">
            <GroupCallButton :recipients="data.value" :iconOnly="true" />
        </template>
    </b-table>
    <TablePagination 
        :total-rows="totalRows" 
        :per-page="perPage" 
        @pageChange="onPageChange">
    </TablePagination>
</div>    
</template>

<script>
import vehicleGroup from '@/store/realtime/vehicleGroup';
import GroupCallButton from '@/components/Dispatching/VoIP/GroupCallButton';

export default {
    components: {
        GroupCallButton
    },
    props: ['filter'],
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            filteredRows: 0
        }
    },
    computed: {
        fields() {
            return [
                { key: 'name', label: this.$t('vehicle_groups.name') },
                { key: 'organization', label: this.$t('vehicle_groups.organization') },
                { key: 'actions', label: this.$t('vehicle_groups.actions'), formatter: (value, key, item) => {
                    let list = [];
                    if (Array.isArray(item.vehicles)) {
                        for (const v of item.vehicles) {
                            if (v.features && v.features.SIP_CLIENT_ID) {
                                list.push(v.features.SIP_CLIENT_ID);
                            }
                        }

                    }
                    return list;
                }}
            ];
        },
        items () { 
            return this.$store.state.vehicleGroup.vehicleGroupList;
        },
        totalRows() {
            return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
        }
    },
    beforeCreate() {
        if (!this.$store.state.vehicleGroup) {
            this.$store.registerModule('vehicleGroup', vehicleGroup);
        }
        this.$store.dispatch('vehicleGroup/getVehicleGroupList');
    },
    methods: {
        onRowSelected (items) {
            this.$emit('selectItem', items[0]);
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page){
            this.currentPage = page;
        }
    }
}
</script>